//import React from 'react';
//import './App.css';
//import LandingPage from './component/landing/LandingPage';
//
//function App() {
//  return (
//    <div className="App">      
//      <LandingPage />
//    </div>
//  );
//}
//export default App;

// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './component/landing/LandingPage';
import RedirectHandler from './component/redirecthandler';

function App() {
  return (
    <Router>
      <Routes>
        {/* Home page - Landing page with URL shortener */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Redirect handler - Catches all short codes like /abc123 */}
        <Route path="/:shortCode" element={<RedirectHandler />} />
        
        {/* Optional: 404 page */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
}

export default App;